import script from "./HeadBlocks.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeadBlocks.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__